import _defineProperty from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useRef as e, useEffect as n, useLayoutEffect as t } from "react";
import { Subject as r } from "rxjs";
import o from "screenfull";
import { jsx as i } from "react/jsx-runtime";
import { useSpring as s, animated as u } from "react-spring";

function c() {
  var t = e(new r());
  return {
    useListenToCustomEvent: function useListenToCustomEvent(e) {
      n(function () {
        var n = t.current.subscribe(e);
        return function () {
          return n.unsubscribe();
        };
      }, [e]);
    },
    emitObservable: function emitObservable(e) {
      t.current.next(e);
    }
  };
}

var l = "undefined" != typeof window ? t : n;

function f(n) {
  var t = e(!1);
  l(function () {
    if (!t.current) {
      var _e = n();

      return t.current = !0, function () {
        _e && _e();
      };
    }
  }, []);
}

function a(_ref) {
  var n = _ref.mainCarouselWrapperRef,
      t = _ref.emitObservable,
      r = _ref.handleResize;
  var i = e(!1);

  function s(e) {
    i.current = e;
  }

  return f(function () {
    function e() {
      document.fullscreenElement && (s(!0), t({
        eventName: "onFullscreenChange",
        isFullscreen: !0
      }), r && r()), document.fullscreenElement || (s(!1), t({
        eventName: "onFullscreenChange",
        isFullscreen: !1
      }), r && r());
    }

    if (o.isEnabled) return o.on("change", e), function () {
      o.isEnabled && o.off("change", e);
    };
  }), {
    enterFullscreen: function enterFullscreen(e) {
      o.isEnabled && o.request(e || n.current);
    },
    exitFullscreen: function exitFullscreen() {
      o.isEnabled && o.exit();
    },
    getIsFullscreen: function getIsFullscreen() {
      return i.current;
    }
  };
}

function m(_ref2) {
  var n = _ref2.items,
      t = _ref2.withThumbs,
      _ref2$thumbsSlideAxis = _ref2.thumbsSlideAxis,
      r = _ref2$thumbsSlideAxis === void 0 ? "x" : _ref2$thumbsSlideAxis,
      o = _ref2.springConfig,
      c = _ref2.prepareThumbsData,
      _ref2$getFluidWrapper = _ref2.getFluidWrapperScrollValue,
      l = _ref2$getFluidWrapper === void 0 ? function () {
    return 0;
  } : _ref2$getFluidWrapper,
      _ref2$getSlideValue = _ref2.getSlideValue,
      a = _ref2$getSlideValue === void 0 ? function () {
    return 0;
  } : _ref2$getSlideValue,
      m = _ref2.slideType;

  var h = e(null),
      _s = s(function () {
    return {
      x: 0,
      y: 0,
      config: o,
      onChange: function onChange(_ref3) {
        var e = _ref3.value;
        h.current && "fluid" === m && (h.current["x" === r ? "scrollLeft" : "scrollTop"] = Math.abs(e[r]));
      }
    };
  }),
      _s2 = _slicedToArray(_s, 2),
      p = _s2[0],
      d = _s2[1];

  function b() {
    return h.current["x" === r ? "scrollLeft" : "scrollTop"];
  }

  function g() {
    var e;
    return Math.round(Number(null === (e = h.current) || void 0 === e ? void 0 : e["x" === r ? "scrollWidth" : "scrollHeight"]) - h.current.getBoundingClientRect()["x" === r ? "width" : "height"]);
  }

  function x() {
    var e = Math.round(l() / a());
    return g() / e;
  }

  f(function () {
    if (t && !h.current) throw new Error("The thumbs wrapper is not defined. If you've passed a Functional component, be sure to wrap your component in forwardRef.");
  });
  return {
    thumbsFragment: t ? i(u.div, Object.assign({
      ref: h,
      className: "use-spring-carousel-thumbs-wrapper",
      onWheel: function onWheel() {
        p[r].stop();
      },
      style: Object.assign({
        display: "flex",
        flex: 1,
        position: "relative",
        width: "100%",
        height: "100%",
        flexDirection: "x" === r ? "row" : "column"
      }, "x" === r ? {
        overflowX: "auto"
      } : {
        overflowY: "auto",
        maxHeight: "100%"
      })
    }, {
      children: function () {
        function e(e) {
          return e.map(function (e) {
            return {
              id: e.id,
              renderThumb: e.renderThumb
            };
          });
        }

        return c ? c(e(n)) : e(n);
      }().map(function (_ref4) {
        var e = _ref4.id,
            n = _ref4.renderThumb;
        var t = "thumb-".concat(e);
        return i("div", Object.assign({
          id: t,
          className: "thumb-item"
        }, {
          children: n
        }), t);
      })
    })) : null,
    handleThumbsScroll: function handleThumbsScroll(e, t) {
      if ("fluid" === m) {
        var _e2 = g();

        if ("next" === t) {
          var _n = b() + x();

          d.start({
            from: _defineProperty({}, r, b()),
            to: _defineProperty({}, r, _n > _e2 ? _e2 : _n)
          });
        }

        if ("prev" === t) {
          var _e3 = b() - x();

          d.start({
            from: _defineProperty({}, r, b()),
            to: _defineProperty({}, r, _e3 < 0 ? 0 : _e3)
          });
        }
      } else {
        var _o = h.current.querySelector("#thumb-".concat(n[e].id));

        if (_o) {
          var _i = h.current,
              _s3 = "x" === r ? "offsetWidth" : "offsetHeight",
              _u = "x" === r ? "scrollLeft" : "scrollTop",
              _c = function (_ref5) {
            var e = _ref5.thumbNode,
                n = _ref5.offsetDirection,
                t = _ref5.offsetDimension;
            return e[n] + e[t] / 2;
          }({
            thumbNode: _o,
            offsetDimension: _s3,
            offsetDirection: "x" === r ? "offsetLeft" : "offsetTop"
          }),
              _l = function (_ref6) {
            var e = _ref6.thumbWrapper,
                n = _ref6.offsetDimension;
            return e[n] / 2;
          }({
            thumbWrapper: _i,
            offsetDimension: _s3
          }),
              _f = function (_ref7) {
            var e = _ref7.thumbWrapper,
                n = _ref7.scrollDirection;
            return e[n];
          }({
            thumbWrapper: _i,
            scrollDirection: _u
          }),
              _a = function (_ref8) {
            var t = _ref8.thumbWrapper,
                o = _ref8.thumbOffsetPosition,
                i = _ref8.thumbScrollDimension,
                s = _ref8.offsetDimension;
            var u = "x" === r ? "scrollWidth" : "scrollHeight";
            return e === n.length - 1 || o - i > t[u] - t[s] ? t[u] - t[s] : 0 === e ? 0 : o - i;
          }({
            thumbWrapper: _i,
            thumbOffsetPosition: _c,
            thumbScrollDimension: _l,
            offsetDimension: _s3
          });

          d.start({
            from: _defineProperty({}, r, _f),
            to: _defineProperty({}, r, "prev" === t && _a < 0 ? 0 : _a),
            onChange: function onChange(_ref9) {
              var e = _ref9.value;
              "x" === r ? h.current.scrollLeft = e.x : h.current.scrollTop = e.y;
            }
          });
        }
      }
    }
  };
}

export { c as a, a as b, m as c, f as d, l as u };